var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$yotpo.enabled)?_c('div',{class:{ 'relative': _vm.$storyblok.isEditing }},[_c('ImageCarousel',{attrs:{"albumId":_vm.data.galleryId}}),(_vm.$storyblok.isEditing)?_c('div',{staticClass:"absolute inset-0 z-50"}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }